// extracted by mini-css-extract-plugin
export default {"mobile_nav":"MobileNavigation_mobile_nav__0fVKS","close_button":"MobileNavigation_close_button__VPv5-"};